<template>
  <div class="page" v-cloak>
    <div class="mang">
      <div class="banner">
        <img :src="api + info.url" alt="" />
      </div>
      <div class="sub-content">
        <div class="title">
          <template v-if="info.id == 1316">
            中国医师协会内镜医师分会年会暨2024中国内镜医师大会壁报展播
          </template>
          <template v-else-if="info.out_name">
            {{ info.out_name }}
          </template>
          <template v-else>
            {{ info.name }}
          </template>
        </div>
        <div class="border">
          <div class="with-line">
            <i>
              <img src="../assets/du.png" alt="" />
            </i>
          </div>
        </div>
        <div class="search-box">
          <el-input
            prefix-icon="el-icon-search"
            v-model="sou"
            placeholder="壁报作者 / 题目"
            @input="onSearch()"></el-input>
        </div>
        <div class="sort">
          <i class="el-icon-sort"></i>
          <div @click="onSort" :style="sort ? 'color:#409EFF;font-size:1rem' : ''">默认排序</div>
          <span> / </span>
          <div @click="onSort" :style="!sort ? 'color:#409EFF;font-size:1rem' : ''">点赞量排序</div>
        </div>
        <div style="margin-top: 1rem" class="bibao-details clearfix" v-if="getlist != ''">
          <div
            class="js_show_photoswiper bibao-details-item"
            :id="'List' + item.id"
            ref="ListId"
            v-for="(item, index) in getlist"
            :key="index"
            @click="onWallDetail(item)">
            <div class="bd-title">
              <div class="bd-title-p1 overflow-text" style="height: 100%">
                {{ item.title }}
              </div>
            </div>
            <div class="relative clearfix">
              <div class="bd-item-left left">
                <div class="bd-subtitle clearfix">
                  <div class="image">
                    <img src="../assets/image/people.png" alt="" />
                  </div>
                  <p class="bd-title-p1 left">
                    <!-- <svg t="1667283338334" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2778" width="200" height="200"><path d="M512.498688 574.347264c-60.248064 0-116.678656-27.23328-158.885888-76.678144-41.314304-48.397312-64.06144-112.515072-64.06144-180.543488 0-68.028416 22.747136-132.144128 64.06144-180.542464C395.820032 87.131136 452.245504 59.904 512.498688 59.904c60.256256 0 116.67968 27.23328 158.886912 76.673024 41.314304 48.398336 64.067584 112.519168 64.067584 180.547584 0 68.027392-22.754304 132.145152-64.067584 180.543488C629.179392 547.113984 572.754944 574.347264 512.498688 574.347264L512.498688 574.347264zM512.498688 106.155008c-97.429504 0-176.702464 94.63808-176.702464 210.970624 0 116.332544 79.27296 210.971648 176.702464 210.971648 97.435648 0 176.702464-94.639104 176.702464-210.971648C689.201152 200.793088 609.93536 106.155008 512.498688 106.155008L512.498688 106.155008zM512.498688 106.155008" p-id="2779" fill="#CDA630"></path><path d="M116.424704 964.727808c-0.892928-4.893696-21.103616-120.966144 58.790912-216.8832 66.341888-79.637504 179.893248-120.019968 337.503232-120.019968l0 46.253056c-78.189568 0-144.811008 10.5984-198.008832 31.505408-43.493376 17.09056-78.467072 41.2672-103.95136 71.86944-66.184192 79.44704-49.021952 177.928192-48.838656 178.917376L116.424704 964.727808 116.424704 964.727808zM116.424704 964.727808" p-id="2780" fill="#CDA630"></path><path d="M908.573696 964.727808l-45.489152-8.358912 22.742016 4.176896-22.75328-4.11648c0.044032-0.252928 4.458496-25.74848 0.367616-60.7744-5.3504-45.863936-22.03648-85.789696-49.589248-118.674432-25.52832-30.473216-60.514304-54.551552-103.977984-71.564288-53.12512-20.79744-119.610368-31.33952-197.597184-31.33952L512.27648 627.82464c157.613056 0 271.164416 40.383488 337.50528 120.019968C929.678336 843.761664 909.473792 959.834112 908.573696 964.727808L908.573696 964.727808zM908.573696 964.727808" p-id="2781" fill="#CDA630"></path></svg> -->
                    作者：
                  </p>
                  <div class="bd-title-p1 left bd-item-right" style="width: calc(100% - 4rem)">
                    <p class="bd-title-p3 overflow-text">
                      {{ item.author }}
                    </p>
                  </div>
                </div>
                <div class="bd-subtitle clearfix">
                  <div class="image">
                    <img src="../assets/image/city.png" alt="" />
                  </div>
                  <p class="bd-title-p1 left">
                    <!-- <svg t="1667283376082" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4671" width="200" height="200"><path d="M847.07 795.895V510.951c0-23.796-13.828-45.564-35.229-55.456L613.01 363.59v-95.484c0-48.523-39.477-88-88-88H264.93c-48.523 0-88 39.477-88 88v527.789h-62.712v48H909.782v-48H847.07z m-622.14 0v-527.79c0-22.056 17.944-40 40-40h260.08c22.056 0 40 17.944 40 40v527.789H224.93z m388.08 0V416.469l178.692 82.597c4.477 2.069 7.368 6.734 7.368 11.886v284.943H613.01z" p-id="4672" fill="#CDA630"></path><path d="M280.779 322.432H509.16v48H280.779zM280.779 458.223H434.99v48H280.779zM486.526 574.339h-42.917c-2.476 0-4.79 1.171-6.202 3.147l-61.614 85.169-22.285-31.033c-1.408-1.968-3.724-3.142-6.197-3.142H304.49a7.603 7.603 0 0 0-6.783 4.155 7.627 7.627 0 0 0 0.581 7.956l71.496 98.886c1.455 2.001 3.698 3.148 6.154 3.148s4.7-1.15 6.153-3.147L492.727 586.45a7.622 7.622 0 0 0 0.581-7.957 7.603 7.603 0 0 0-6.782-4.154z" p-id="4673" fill="#CDA630"></path></svg> -->
                    单位：
                  </p>
                  <div class="bd-title-p1 left bd-item-right">
                    <p class="bd-title-p3 overflow-text">{{ item.company }}</p>
                  </div>
                </div>
                <div class="bd-subtitle clearfix">
                  <div class="SortHover" @click.stop="onisUpvote(item.id, index)">
                    <div class="Sort_img">
                      <img
                        src="../assets/image/Sort.png"
                        alt=""
                        v-if="UpvoteIdList.includes(item.id)" />
                      <img src="../assets/image/Sortclone.png" alt="" v-else />
                    </div>
                    <div style="margin-left: 0.5rem" v-if="item.upvote > 0">
                      {{ item.upvote }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="bibao-item-image right bg-img" style="display: inline-block">
                <img
                  style="width: 100%; height: 100%"
                  :src="api + 'pdf_image/' + item.url_arr[0]" />
              </div>
            </div>
          </div>
        </div>
        <div class="none" v-else>暂无数据</div>
      </div>
    </div>
    <div class="bg-img pdf-list" style="display: none"></div>
    <div class="tou" @click="toupush()" v-if="info.submission_button_status == 1">
      <div class="jia">+</div>
      <div class="title">投稿</div>
    </div>
    <div class="tou" style="top: 50%" @click="fan()">
      <div class="jia">
        <svg
          style="width: 1.5rem; height: 1.5rem"
          t="1667812507438"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6125">
          <path
            d="M482.7 249.9V106.1c0-37.4-45.3-56.2-71.7-29.7L140.3 347c-16.4 16.4-16.4 43 0 59.4L410.9 677c26.5 26.5 71.7 7.7 71.7-29.7v-155c96.1-0.3 271.5-10.7 271.5 227.7 0 118.1-92.8 216.8-216 239.6 198.1-24.4 326-236 326-361.9 0.1-292.6-309.4-346.3-381.4-347.8z"
            fill="#ffffff"
            p-id="6126"></path>
        </svg>
      </div>
      <div class="title">返回</div>
    </div>
    <a href="javascript:scroll(0,0)">
      <div class="ding">
        <div class="jia">
          <img src="../assets/image/arrow-up.png" alt="" />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
// import * as PDFJS from "pdfjs-dist";
// import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
// PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import { getLiteratureList } from '@/api/api';
import Home from '../mixins/home';
// https://pay.iceriverbj.com/uploads/20240820/7f10516923075efac65c0756c7440921.jpg
// https://pay-pre.iceriverbj.com/uploads/20240820/7f10516923075efac65c0756c7440921.jpg

function debounce(func, wait) {
  let timeoutId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(context, args), wait);
  };
}
export default {
  name: 'Home',
  mixins: [Home],
  components: {
    // HelloWorld,
  },
  data() {
    return {
      sou: '',
      event_id: '',
      api: process.env.VUE_APP_BASE_API,
      id: '',
      info: {},
      images: [],
      getlist: [],
      originalList: [],
      canvasArr: [],
      totalCount: 0,
      loading: false,
      scale: 2,
      interval: 0,
      PageNum: 1,
      sort: true,
      renderImgArr: [],
      ds: [],
    };
  },
  activated() {
    // 当组件被 keep-alive 激活时调用
    this.scrollToElement();
    console.log('组件被激活');
  },
  beforeRouteLeave(to, from, next) {
    // 当离开当前路由时，清除 sessionStorage
    sessionStorage.removeItem('ListId');
    next();
  },
  created() {
    if (this.$route.query.keyword) {
      this.sou = this.$route.query.keyword;
    }
  },
  mounted() {
    this.event_id = this.$route.query.event_id;
    this.id = this.$route.query.id;
    this.info = JSON.parse(this.$route.query.info);
    if (this.event_id == 1316) {
      document.title = '中国医师协会内镜医师分会年会暨2024中国内镜医师大会壁报展播';
    } else {
      document.title = this.info.name;
    }
    this.Sin();
    this.debouncedHandleScroll = debounce(this.handleScroll, 200); // 延迟 200 毫秒
    window.addEventListener('scroll', this.debouncedHandleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 清理事件监听
  },
  methods: {
    scrollToElement() {
      const id = this.$route.query.ListId;
      console.log(id);

      if (id) {
        this.scrollTo(id);
      } else {
        const Url = JSON.parse(sessionStorage.getItem('ListId'));
        console.log(Url);

        if (Url && Url.ListId) {
          this.scrollTo(Url.ListId);
        }

        sessionStorage.removeItem('ListId');
      }
    },

    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 1000); // 可以根据实际情况调整延迟时间
    },
    handleScroll(event) {
      // 获取页面的滚动位置
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      let isLoading = false; // 用于标记是否正在加载数据
      console.log(scrollTop + windowHeight, documentHeight);
      // 判断是否触底
      if (scrollTop + windowHeight >= documentHeight - 100 && !isLoading) {
        // 获取当前数据条数和总数据条数
        const currentDataCount = this.getlist.length;
        const totalDataCount = this.totalCount;
        // 如果当前数据条数小于总数据条数，触发加载更多数据
        if (currentDataCount < totalDataCount) {
          // 当搜索没有值时才调用加载更多数据
          this.PageNum++; // 自增页码
          isLoading = true; // 设置加载状态为 true
          this.Sin();
        } else {
          console.log('已加载所有数据，停止加载');
        }
      }
    },
    Sin() {
      getLiteratureList({
        event_id: this.event_id,
        type: 2,
        category_id: this.id,
        title: this.sou,
        author: this.sou,
        pageNumber: this.PageNum,
        sort: this.sort ? 'default' : 'upvote',
      })
        .then((response) => {
          if (response.code == 1) {
            this.totalCount = response.data.totalResult;

            // 根据 Sort 的状态决定是否合并新数据
            if (!this.sort) {
              // 如果 Sort 为 false，，直接使用新数据
              this.getlist = [...this.getlist, ...response.data.list];
            } else {
              // 如果 Sort 为 true，合并不重复的新数据
              this.originalList.push(...response.data.list);
              this.getlist.push(...response.data.list);
              // // 按照点赞数量降序排序
              // this.getlist.sort((a, b) => b.upvote - a.upvote);
            }
          } else {
            this.getlist = [];
            this.originalList = [];
          }
        })
        .catch((err) => {
          this.getlist = [];
        });
    },
    fan() {
      this.$router.push({
        path: '/',
        query: {
          event_id: this.event_id,
        },
      });
    },
    toupush() {
      this.$router.push({
        path: '/leve',
        query: {
          id: this.id,
          event_id: this.event_id,
          info: JSON.stringify({
            images: this.info.event_image,
            name: this.info.name,
          }),
        },
      });
    },
    // 壁报详情
    onWallDetail(Val) {
      this.$router.push({
        path: '/homeDetails',
        query: {
          event_id: this.event_id,
          ListId: Val.id,
          id: Val.id,
          title: this.info.out_name ? this.info.out_name : this.info.name,
        },
      });
    },
    onSearch() {
      this.totalCount = 0;
      this.getlist = []; // 清空当前列表
      this.originalList = []; // 清空原始列表
      this.PageNum = 1;
      getLiteratureList({
        event_id: this.event_id,
        type: 2,
        category_id: this.id,
        author: this.sou,
        pageNumber: 1,
        title: this.sou,
      }).then((response) => {
        if (response.code == 1) {
          this.totalCount = response.data.totalResult;
          this.getlist = response.data.list;
          this.originalList = [...this.getlist]; // 确保 originalList 也被正确设置
        } else {
          // 这里可以选择不调用 Bust，避免重复添加数据
          console.log('查询失败，未加载数据');
        }
      });
    },
    // 改变排序方式
    onSort() {
      this.sort = !this.sort;
      this.PageNum = 1;
      // 创建原数组的副本，以便在排序时不修改原数组
      if (this.sort) {
        // 当 sort 为 true 时，恢复到原始顺序
        this.getlist = [...this.originalList]; // 使用原始数组
      } else {
        getCategoryList({
          event_id: this.event_id,
          category_status: this.getlConfig.category_status,
          pageNumber: this.PageNum,
          title: this.sou,
          sort: this.sort ? 'default' : 'upvote',
        }).then((response) => {
          if (response.code == 1) {
            this.getlist = [];
            this.totalCount = response.data.totalResult;
            this.getlist = response.data.list;
            // 根据 Sort 的状态决定是否进行排序
            if (!this.sort) {
              // 如果 Sort 为 false，按照点赞数量降序排序
              this.getlist.sort((a, b) => b.upvote - a.upvote);
            }
          } else {
            this.getlist = [];
            this.originalList = [];
          }
        });
        // 按照点赞数量降序排序
        this.getlist.sort((a, b) => b.upvote - a.upvote);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.page {
  .banner {
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .sub-content {
    padding: 1rem;
    font-size: 0.6rem;
    padding-bottom: 1.5rem;
    flex: 1;
    word-break: break-word;
    .title {
      width: 100%;
      text-align: center;
      font-size: 1.3rem;
      font-weight: 500;
      // margin: 20px;
    }
    .border {
      width: 100%;
      display: inline-flex;
      justify-content: center;
      .with-line {
        width: 93%;
        font-size: 16px;
        color: #999;
        margin: 0 auto;
        position: relative;
        text-align: center;

        img {
          width: 3.5rem;
          height: 3.5rem;
        }
      }

      .with-line:before {
        content: '';
        border-top: 2px solid #ededed;
        display: block;
        position: absolute;
        width: 40%;
        top: 50%;
        left: 0;
        margin-right: 12px;
      }

      .with-line:after {
        content: '';
        border-top: 2px solid #ededed;
        display: block;
        position: absolute;
        width: 40%;
        top: 50%;
        right: 0;
        margin-left: 12px;
      }
    }
    .search-box {
      padding: 0.4rem 1rem;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      //   border: 1px solid #ddd;
      // height: 1.8rem;
      -webkit-border-radius: 0.9rem;
      -moz-border-radius: 0.9rem;
      border-radius: 0.9rem;
      position: relative;
      overflow: hidden;
      // background-color: #fff;
      .van-cell-group::after {
        border: none !important;
      }
    }
    .sort {
      display: flex;
      align-items: center;
      color: #606266;
      font-size: 0.8rem;
      padding: 1rem 1rem;
      box-sizing: border-box;

      i {
        color: #409eff;
        margin: 0.2rem 0.6rem 0px 0px;
        font-size: 0.8rem;
      }

      span {
        margin: 0 5px;
        color: #606266;
      }
    }
    .flex {
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
    }
  }

  .bibao-details-item {
    background: #ffffff;
    border: 0px solid #000000;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 0.5rem;
    display: block;
    padding: 0 0 0.5rem 0;
    box-sizing: border-box;
    .bd-title {
      padding: 0.7rem;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 0.9rem;
      color: #000000;
      box-sizing: border-box;
      border-bottom: 1px solid #ededed;
    }
    .relative {
      position: relative;
      font-size: 0.8rem;
      display: flex;

      .left {
        display: inline-block;
      }

      .bd-item-left {
        width: calc(100% - 8.7rem);

        .bd-subtitle {
          padding: 0.5rem 0 0 0.7rem;
          display: flex;
          .image {
            width: 0.7rem;
            height: 0.7rem;
            margin-right: 0.7rem;
            img {
              width: 0.7rem;
              height: 0.7rem;
            }
          }
          .bd-title {
            .bd-title-p1 {
              width: 100%;
              font-size: 1rem;
              color: #333333;
              border-bottom: 1px solid #eeeeee;

              svg {
                border: none;
                background: none;
                box-shadow: none;
                margin-right: 3px;
              }
            }
          }

          .SortHover {
            min-width: 3rem;
            min-height: 2rem;
            color: #fff;
            text-align: center;
            background-color: #409eff;
            background: #409eff;
            border-radius: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.8rem 0.8rem;
            margin: 1rem 0;
            box-sizing: border-box;

            .Sort_img {
              width: 1rem;
              height: 1rem;

              img {
                width: 1rem;
                height: 1rem;
              }
            }

            &:hover {
              cursor: pointer;
            }
          }

          .bd-title-p3 {
            color: #333333;
            display: block;
            -webkit-align-self: flex-end;
            -ms-flex-item-align: end;
            align-self: flex-end;
          }

          .overflow-text {
            display: block;
          }

          .bd-item-right {
            width: calc(100% - 5.4rem);
          }
        }
      }

      .bibao-item-image {
        width: 5.5rem;
        height: 8.5rem;
        padding: 0.5rem 0.5rem 0 0.7rem;
      }
    }
  }
  .none {
    text-align: center;
    margin: 12px;
    font-size: 1.2rem;
    color: #b3b3b3;
  }
  .clearfix:before,
  .clearfix:after {
    clear: both;
    content: '';
    display: table;
  }
  @media screen and (min-width: 1201px) {
    .banner img {
      width: 1200px;
      display: block;
      margin: 0 auto;
    }
    .sub-content,
    .banner {
      width: 1200px;
      display: block;
      margin: 0 auto;
    }
    .bibao-item {
      width: 16.666666% !important;
    }
  }
  @media screen and (min-width: 769px) {
    .bibao-details .bibao-details-item:nth-child(2n-1) {
      margin-right: 0.5rem;
      margin-top: 0.5rem;
    }
  }
  @media screen and (min-width: 769px) {
    .bibao-details .bibao-details-item {
      width: -webkit-calc(99.5% / 2);
      width: -moz-calc(99.5% / 2);
      width: calc((100% - 0.5rem) / 2);
      float: left;
    }
  }
  .tou {
    position: fixed;
    top: 80%;
    right: 1.5rem;
    width: 4rem;
    height: 4rem;
    background: rgba(123, 123, 123, 0.6);
    border-radius: 50%;
    .jia {
      font-size: 1rem;
      text-align: center;
      color: #fff;
      margin-top: 0.4rem;
    }
    .title {
      font-size: 14px;
      color: #fff;
      text-align: center;
    }
  }
  .ding {
    position: fixed;
    top: 90%;
    right: 1.5rem;
    width: 3rem;
    height: 3rem;
    .jia {
      font-size: 2.5rem;
      img {
        width: 3rem;
        height: 3rem;
      }
    }
  }
  svg {
    width: 1rem;
    height: 1rem;
    // background: #ffffff;
    // border: 0px solid #000000;
    // box-shadow: 0px 0px 17px 1px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
  }
}
</style>
